import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { FormattedContent } from '@jotta/ui/FormattedContent'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import { RadixModal } from '@jotta/ui/RadixModal'

export const ConfirmDeleteDialog: React.FC<{
  open?: boolean
  onConfirm: () => void
  onClose: () => void
}> = ({ onConfirm, onClose, open = false }) => {
  const confirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <RadixModal open={open} onClose={onClose}>
      <RadixDialog
        title={t`Delete comment`}
        buttons={[
          { action: onClose, label: t`Cancel`, type: 'outline' },
          {
            action: confirm,
            label: t`Yes, delete comment`,
            type: 'destructive',
          },
        ]}
      >
        <FormattedContent>
          <p>
            <Trans>Are you sure you want to delete this comment?</Trans>
          </p>
        </FormattedContent>
      </RadixDialog>
    </RadixModal>
  )
}
